import { USER_ROLES } from '../constants/Values';

/**
 * Roles that may compose / cancel / act on DIVERSION notices.
 *
 * Mirrors the four backend roles per overall design D12 (TRANSPORTATION_MANAGER,
 * CRISIS_TEAM_MEMBER, SECURITY_MANAGER, COMMUNICATION_MANAGER) PLUS the platform
 * ADMIN role. ADMIN included per Matt's directive 2026-05-05 — admins historically
 * have every privilege and gating them out of DIVERSION would be inconsistent with
 * the rest of the admin console.
 *
 * SUPERVISOR is intentionally EXCLUDED — confirmed 2026-05-05 (overview § Cross-cutting rules).
 * The backend treats SUPERVISOR as a low-privilege bus-staff role for marking kids on the bus —
 * not a Transport-Manager-adjacent role for this admin-console feature.
 */
export const DIVERSION_AUTHORITY_ROLES = [
  USER_ROLES.TM,
  USER_ROLES.CTM,
  USER_ROLES.SECURITY,
  USER_ROLES.COMMUNICATION,
  USER_ROLES.ADMIN,
];

/**
 * @param {Array<string>|undefined|null} userRoles - The signed-in user's roles array,
 *   sourced from state.profile.user.roles.
 * @returns {boolean} true if the user has at least one of the five DIVERSION authority roles.
 */
export function canSendDiversion(userRoles) {
  if (!userRoles || userRoles.length === 0) return false;
  return DIVERSION_AUTHORITY_ROLES.some(role => userRoles.includes(role));
}
